export default class SmoothScroll {
  constructor(el){
    this.element = $(el);
    this.speed = 300;
    this.event();
  }

  event(){
    this.element.on('click', e => {
      e.preventDefault();
      let href = this.element.attr('href');
      let $target = $(href);
      if($target.length !== 0){
        this.moveTo(e, $target);
      }
    });
  }

  moveTo(e, target){
    let offset = target.offset().top;
    $('html, body').animate({scrollTop:offset}, this.speed, 'swing');
  }
}




// WEBPACK FOOTER //
// ./js/_modules/_smoothScroll.js